var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForeignVacationSchema(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10225_15447",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10225_15447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 11C5.30833 11 4.65833 10.8687 4.05 10.6062C3.44167 10.3438 2.9125 9.9875 2.4625 9.5375C2.0125 9.0875 1.65625 8.55833 1.39375 7.95C1.13125 7.34167 1 6.69167 1 6C1 5.30833 1.13125 4.65833 1.39375 4.05C1.65625 3.44167 2.0125 2.9125 2.4625 2.4625C2.9125 2.0125 3.44167 1.65625 4.05 1.39375C4.65833 1.13125 5.30833 1 6 1C6.69167 1 7.34167 1.13125 7.95 1.39375C8.55833 1.65625 9.0875 2.0125 9.5375 2.4625C9.9875 2.9125 10.3438 3.44167 10.6062 4.05C10.8687 4.65833 11 5.30833 11 6C11 6.69167 10.8687 7.34167 10.6062 7.95C10.3438 8.55833 9.9875 9.0875 9.5375 9.5375C9.0875 9.9875 8.55833 10.3438 7.95 10.6062C7.34167 10.8687 6.69167 11 6 11ZM5.5 9.975V9C5.225 9 4.98958 8.90208 4.79375 8.70625C4.59792 8.51042 4.5 8.275 4.5 8V7.5L2.1 5.1C2.075 5.25 2.05208 5.4 2.03125 5.55C2.01042 5.7 2 5.85 2 6C2 7.00833 2.33125 7.89167 2.99375 8.65C3.65625 9.40833 4.49167 9.85 5.5 9.975ZM8.95 8.7C9.11667 8.51667 9.26667 8.31875 9.4 8.10625C9.53333 7.89375 9.64375 7.67292 9.73125 7.44375C9.81875 7.21458 9.88542 6.97917 9.93125 6.7375C9.97708 6.49583 10 6.25 10 6C10 5.18333 9.77292 4.4375 9.31875 3.7625C8.86458 3.0875 8.25833 2.6 7.5 2.3V2.5C7.5 2.775 7.40208 3.01042 7.20625 3.20625C7.01042 3.40208 6.775 3.5 6.5 3.5H5.5V4.5C5.5 4.64167 5.45208 4.76042 5.35625 4.85625C5.26042 4.95208 5.14167 5 5 5H4V6H7C7.14167 6 7.26042 6.04792 7.35625 6.14375C7.45208 6.23958 7.5 6.35833 7.5 6.5V8H8C8.21667 8 8.4125 8.06458 8.5875 8.19375C8.7625 8.32292 8.88333 8.49167 8.95 8.7Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForeignVacationSchema);
export default __webpack_public_path__ + "static/media/foreign-vacation-schema.fca518f8fa791849a28a6b26cafbb90d.svg";
export { ForwardRef as ReactComponent };